export const START_CREATE_REQUEST = 'START_CREATE_REQUEST';
export const STOP_CREATE_REQUEST = 'STOP_CREATE_REQUEST';
export const GET_REQUESTS = 'GET_REQUESTS';
export const CREATE_REQUEST = 'CREATE_REQUEST';
